<template>
  <div id="office-viewer" :class="{noCopy:copyStatus}">
    <div class="docx-container">
      <div ref="file"></div>
    </div>
    <van-button id="download" :class="{hide:!downloadStatus}" @click="downloadFile" type="primary" size="small">下载</van-button>
  </div>
</template>
<script>

import axios from 'axios'
const docx = require('docx-preview');

// 如果 docx-preview 版本比较新需要 es6 导出
// import { renderAsync } from 'docx-preview'

window.JSZip = require('jszip')
export default {
  name: 'OfficeViewer',
  beforeCreate() {

  },
  mounted() {


  },
  created() {
    // 获取url参数
    this.id = this.$route.query.id
    this.ids = this.id.split("-")
    // 复制判断
    this.copyStatus = (this.ids[0] + this.ids[3]) % 2 !== 0;
    // 下载判断
    this.downloadStatus = (this.ids[1] + this.ids[3]) % 2 !== 0;
    // 请求文件路径
    this.getFileInfo(this.ids[2]);
    if (this.copyStatus){
      // 禁止复制
      this.noCopy();
    }

  },
  data(){
    return{
      id:null,
      ids: [],
      filePath: null,
      copyStatus: false, // 控制复制
      downloadStatus: false, // 控制下载
    }
  },
  methods: {
    getWordFile(){
      // 请求
      axios({
        method: 'get',
        responseType: 'blob', // 设置响应文件格式
        url: this.filePath,
      }).then(({data}) => {
        docx.renderAsync(data,this.$refs.file) // 渲染到页面预览
      })
    },
    noCopy(){
      this.$nextTick(() => {
        // 禁用右键
        document.oncontextmenu = new Function('event.returnValue=false')
        // 禁用选择
        document.onselectstart = new Function('event.returnValue=false')
        //禁止f12
        document.οnkeydοwn = new Function('event.returnValue=false')
      })

      // 上面的禁止f12那段代码没有生效，但是加了下面这段就能生效。
      document.onkeydown = function (e) {
        if (e && e.keyCode === 123) {
          e.returnValue = false
          // e.keyCode = 0   //去掉也可以的，倘若要写，则需要setter 以及 getter配合使用，不配合，会报错
          return false
        }
      }
    },
    downloadFile(){
      // 下载文件
      if (this.downloadStatus) {
        window.open(this.filePath)
      }
    },
    getFileInfo(id) {
      const { $http } = this;
      let path = "resource/query?id="+id;
      $http.get(path).then((res) => {
        console.log("res",res)
        let data = res.data;
        console.log("data",data);
        if (data.hasOwnProperty("filePath")){
          this.fileName = data["fileTitle"]; // 获取文件名称
          this.filePath = data["filePath"];
          // 请求文件
          this.getWordFile();
          console.log("fileName",this.fileName)
          console.log("url",this.filePath)
        }
      });
    },
  },

}
</script>

<style scoped>
.noCopy{
  -webkit-touch-callout:none;/*系统默认菜单被禁用*/
  -webkit-user-select:none;/*webkit浏览器*/
  -khtml-user-select:none;/*早起浏览器*/
  -moz-user-select:none;/*火狐浏览器*/
  -ms-user-select:none;/*IE浏览器*/
  user-select:none;/*用户是否能够选中文本*/
}
#download{
  position: absolute;
  right: 5px;
  top: 10px;
  z-index: 10000;
}
.hide{
  display: none;
}
.docx-container ::v-deep .docx-wrapper {
  background-color: #fff;
  padding: 20px 20px;
  overflow-y: scroll;
  overflow-x: scroll;
}
.docx-container ::v-deep .docx-wrapper > section.docx {
  width: 95vw !important;
  padding: 0rem !important;
  min-height: auto !important;
  box-shadow: none;
  margin-bottom: 0;
  overflow-y: scroll;
  overflow-x: scroll;
  height: auto;
}
.docx-container ::v-deep .docx-wrapper > section.docx::-webkit-scrollbar {
  display: none;
}
.docx-container ::v-deep img{
  width: 95vw !important;
  height: auto !important;
}
</style>